
import { Theme } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';

interface IProps {
  fullPage?: boolean;
  hideOverflow?: boolean;
  listPadding?: boolean;
  sideBySide?: boolean;
  smallScreenNoPadding?: boolean;
  classes?: any;
  noPaddingMargin?: boolean;
}

const styles = (theme: Theme, { noPaddingMargin }: IProps) => ({
  container: {
    flex: 1,
    overflowX: 'hidden',
    boxSizing: 'border-box',
  },
  fullPage: {
    padding: noPaddingMargin ? 0 : theme.spacing(3, 5),
    [theme.breakpoints.down('xl')]: {
      padding: noPaddingMargin ? 0 : theme.spacing(2, 2),
    },
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
  },
  fullPageNoPadding: {
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  hideOverflow: {
    height: '100%',
    overflow: 'hidden',
    paddingBottom: 0,
  },
  listPadding: {
    paddingLeft: noPaddingMargin ? 0 : theme.spacing(0),
  },

  sideBySide: {
    padding: noPaddingMargin ? 0 : theme.spacing(1),
    margin: noPaddingMargin ? 0 : theme.spacing(-1),
    height: '100%',
  },
});

export const EDMasonry: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <div
      className={classNames(props.classes.container, {
        [props.classes.fullPage]: props.fullPage,
        [props.classes.hideOverflow]: props.hideOverflow,
        [props.classes.listPadding]: props.listPadding,
        [props.classes.sideBySide]: props.sideBySide,
        [props.classes.fullPageNoPadding]: props.smallScreenNoPadding,
      })}
    >
      {props.children}
    </div>
  );
};

export default withStyles(EDMasonry, styles);
